import React, { useEffect, useState } from 'react'
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import '../../modalright.css'
import '../../popup.css'
import axios from 'axios';
import jQuery from 'jquery';
export default function OrdersView() {
    const API_URL = process.env.REACT_APP_API_URL;
    const $ = jQuery.noConflict();
    useEffect(() => {
        getOrderList();
    }, []);

    const buttonsyle={
        background: '#00a6ed',
        color: '#fff',
        padding: '3px'
    }
    const [isload, setisload] = useState(true);
    const [data, setdata] = useState([])
   

const getOrderList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/jobs/getOrdersByDateAndCode`;
    const emirate = sessionStorage.getItem('selectedEmirate');
const lowercaseEmirate = emirate ? emirate.toLowerCase() : '';
    // Set the parameters to pass in the request
    const params = {
        date: sessionStorage.getItem('selectedDate'),  // You can replace this with dynamic data if needed
        code: lowercaseEmirate          // Same for emirate code
    };

    try {
        // Perform GET request with query parameters
        const res = await axios.get(API_PATH, { params });
        
        // Check if the response is successful
        if (res.data.success) {
            console.log(res.data.data.orders);
            setdata(res.data.data.orders);   // Assuming this updates your state
            setisload(false);                 // Assuming this stops your loading indicator
        } else {
            console.error('Error fetching data:', res.data.errors);
        }
    } catch (err) {
        console.error('Axios error:', err);
    }
};

const columns = [
    // {
    //     name: "Id",
    //     selector: row => row.id || row.order_id,  // In case `id` isn't available in your data, fall back to `order_id`
    //     sortable: true,
    // },
    {
        name: "Order ID",
        selector: row => row.order_id, // Access the order_id directly
        sortable: true,
    },
    {
        name: "AWB",
        selector: row => row.awb, // Access the order_id directly
        sortable: true,
        cell: (row) => (
            <div style={{ width:'800px',wordWrap: 'break-word', whiteSpace: 'normal',textAlign:'left' }}>
               {row.awb} 
            </div>
        ),
    },
    
    {
        name: "Receiver",
        selector: row => row.consignee.name, // Assuming receiver is the same as the sender, so we use the same field
        sortable: true,
    },
    {
        name: "Address",
        selector: row => row.consignee.address, // Access the consignee name as the sender
        sortable: true,
    },
    {
        name: "Order Type",
        selector: row => row.type, // Use the order type (e.g., DROP, DELIVERY)
        sortable: true,
    },
    {
        name: "From",
        selector: row => row.origin || 'Not Specified', // Use origin if available, otherwise default to "Not Specified"
        sortable: true,
    },
    {
        name: "To",
        selector: row => row.destination, // Use the destination for the "To" field
        sortable: true,
    },
    {
        name: "Quantity",
        selector: row => '1', // Assuming quantity is static, as there's no quantity field in your data.
        sortable: true,
    },
    {
        name: "Updated On",
        selector: row => row.updated_on || 'N/A', // Placeholder if `updated_on` is not available
        sortable: true,
    }
];

    


    const tableData = {
      columns,
      data
    };

    

    let subtitle;
  
  const [msg, setmsg] = useState('')



  
  return (
    <div className="wrapper-holder">
   
    <div className="main-panel ps-container">                
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">                                  
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Orders <span style={{ float: 'right' }}> </span></h4>
                                <p className="card-category"></p>
                            </div>
                            
                            <div className="card-body">
                            {
                                isload?(
                                    <div style={{textAlign:"center"}}>
                                        <p style={{textAlign:"center"}}>Please wait. The data is loading ! </p>
                                    </div>
                                ):(
                                
                                <div className="tableContainer1">
                                    <DataTableExtensions {...tableData}
                                    >
                                    <DataTable 
                                        columns={columns}
                                        data={data}
                                        noHeader
                                        defaultSortField="id"
                                        // sortIcon={<SortIcon />}
                                        defaultSortAsc={true}
                                        pagination
                                        highlightOnHover
                                        dense
                                        
                                    />
                                    </DataTableExtensions>

                                    <div className="ActionsBar_right_ttCWs">
                                  <a href="/orders/configure" style={buttonsyle} type="button" className="btn-demo add" ><i className="fa fa-plus" aria-hidden="true"></i>Next</a>
                                </div> 
                                    </div>
                                )
                            }
                            </div> 

                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>

       

</div>
  )
}
